<template>
  <v-container>
    <v-card outlined v-if="value.type===1">
      <v-card-text>
        <v-select
            :clearable="clearable"
            :label="value.title"
            :items="value.items"
            return-object
            item-value="id"
            item-text="value"
            :value="value.selected?value.selected:null"
            @input="field_change"
        >
        </v-select>
      </v-card-text>
    </v-card>
    <TagManager @tag_change="field_change" v-if="value.type===2" :label="value.title" :tags="value.selected_tags"
                :field_id="value.id"/>
    <v-card outlined v-if="value.type===3">
      <v-card-text>
        <v-textarea
            :value="value.value?value.value:null"
            outlined
            :label="value.title"
            @input="field_change"
        >
        </v-textarea>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import TagManager from "./TagManager";

export default {
  name: "Field",
  components: {TagManager},
  props: {
    value: {
      type: Object,
      required: true
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    field_change(new_val) {
      this.$emit('field_change', {"old_object": this.value, "new_value": new_val})
    }
  }

}
</script>

<style scoped>

</style>
